import MessagesRepository from '@/repositories/entity/LineMessagesRepository'
import LineMessagesRepository from '@/repositories/entity/LineMessagesRepository'

export default {
  namespaced: true,
  state: {
    drafts: [],
    draft: {
      data: [],
      pagination: {}
    },
    templates: [],
    template: {
      data: [],
      pagination: {}
    },
    history: [],
    historyObject: {
      data: [],
      pagination: {}
    },
    filters: [],
    lineMessage: [],
    remindTemplate: [],
    thankTemplate: [],
    lineInfo: {
      used: 0,
      limit: 0
    },
    messageCounter: 0,
    userListSent: [],
  },
  getters: {
    drafts: (state) => state.drafts,
    templates: (state) => state.templates,
    history: (state) => state.history,
    remindTemplate: (state) => state.remindTemplate,
    thankTemplate: (state) => state.thankTemplate,
    lineInfo: (state) => state.lineInfo,
    userListSent: (state) => state.userListSent,
  },
  mutations: {
    getTemplates(state, data) {
      state.templates = data.data
      state.template.data = data.data.data
      state.template.pagination = data.data.pagination
    },
    getHistory(state, data) {
      state.history = data.data
      state.historyObject.data = data.data.data
      state.historyObject.pagination = data.data.pagination
    },
    getDrafts(state, data) {
      state.drafts = data.data
      state.draft.data = data.data.data
      state.draft.pagination = data.data.pagination
    },
    getFilters(state, data) {
      state.filters = data
    },
    show(state, data) {
      state.lineMessage = data
    },
    getRemindTemplates(state, data) {
      state.remindTemplate = data
    },
    setLineInfo(state, data) {
      state.lineInfo = data
    },
    getThankTemplates(state, data) {
      state.thankTemplate = data
    },
    setMessageCounter(state, data) {
      state.messageCounter = data;
    },
    setUsersWithLineIdSentSuccessfully(state, data) {
      state.userListSent = data.items;
    },
  },
  actions: {
    async getTemplates({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.templates(payload)
        commit('getTemplates', {data})
      } catch (error) {
        throw error
      }
    },
    async delTemplate({commit}, id) {
      try {
        await LineMessagesRepository.delTemplate(id)
      } catch (error) {
        throw error
      }
    },
    async getHistory({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.history(payload)
        commit('getHistory', {data})
      } catch (error) {
        throw error
      }
    },
    async getDrafts({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.drafts(payload)
        commit('getDrafts', {data})
      } catch (error) {
        throw error
      }
    },
    async getFilters({commit}) {
      try {
        const {data} = await LineMessagesRepository.filters()
        commit('getFilters', data)
      } catch (error) {
        throw error
      }
    },

    async show({commit}, id) {
      try {
        const {data} = await LineMessagesRepository.show(id)
        commit('show', data)
      } catch (error) {
        throw error
      }
    },

    async save({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.save(payload)
        if (payload.action == 'fetch') {
          commit('setMessageCounter', data.data.number_message)
        } else {
          commit('getTemplates', data)
        }
      } catch (error) {
        throw error
      }
    },
    async update({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.update(payload)
        commit('getTemplates', data)
      } catch (error) {
        throw error
      }
    },
    async getRemindTemplates({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.getRemindTemplate()
        commit('getRemindTemplates', data.data)
      } catch (error) {
        throw error
      }
    },
    async getLineInfo({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.getLineInfo()
        commit('setLineInfo', data)
      } catch (error) {
        throw error
      }
    },
    async getThankTemplates({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.getThankTemplates()
        commit('getThankTemplates', data.data)
      } catch (error) {
        throw error
      }
    },
    async saveRemindTemplate({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.saveRemindTemplate(
          payload,
        )
        commit('getTemplates', data)
      } catch (error) {
        throw error
      }
    },
    async saveThankTemplate({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.saveThankTemplate(payload)
        commit('getTemplates', data)
      } catch (error) {
        throw error
      }
    },
    async getUsersWithLineIdSentSuccessfully({commit}, payload) {
      try {
        const {data} = await LineMessagesRepository.getUsersWithLineIdSentSuccessfully(payload)
        commit('setUsersWithLineIdSentSuccessfully', data.data)
      } catch (error) {
        throw error
      }
    },
  },
}
